/*eslint-disable indent*/
//TODO: remove this later
class wizardToolbarController {

}

export default wizardToolbarController;
/*eslint-enable indent*/
